// Session warning component

import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface SessionWarningProps {
  timeRemaining: number;
}

export function SessionWarning({ timeRemaining }: SessionWarningProps) {
  const minutes = Math.floor(timeRemaining / 60000);
  const seconds = Math.floor((timeRemaining % 60000) / 1000);

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-5">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <AlertTriangle className="w-5 h-5 text-amber-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-amber-300">
            Your session will expire in <strong className="text-amber-200">{minutes}:{seconds.toString().padStart(2, '0')}</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
